export const mapStyles = [
  {
    elementType: 'geometry',
    stylers: [
      {
        color: '#f5f3f5',
      },
    ],
  },
  {
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#615961',
      },
    ],
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#f5f3f5',
      },
    ],
  },
  {
    featureType: 'administrative.land_parcel',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#bdb5bd',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [
      {
        color: '#eee8ee',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#756e75',
      },
    ],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [
      {
        color: '#e5e1e5',
      },
    ],
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#9e9a9e',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [
      {
        color: '#ffffff',
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#757175',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [
      {
        color: '#dad6da',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#615f61',
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#9e9a9e',
      },
    ],
  },
  {
    featureType: 'transit.line',
    elementType: 'geometry',
    stylers: [
      {
        color: '#e5e1e5',
      },
    ],
  },
  {
    featureType: 'transit.station',
    elementType: 'geometry',
    stylers: [
      {
        color: '#eeebee',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [
      {
        color: '#c9c6c9',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#9e999e',
      },
    ],
  },
];

export const DEFAULT_ZOOM = 3;
export const STATE_LEVEL_ZOOM = 6;
export const COUNTY_LEVEL_ZOOM = 9;
export const SMART_CLUSTERING_ZOOM_BORDER = 11;
export const DEFAULT_CENTER = {
  lat: 40,
  lng: -90,
};
export const IDLE_DEBOUNCE_DELAY = 500;
export const HOVER_DEBOUNCE_DELAY = 500;
export const formatter = Intl.NumberFormat('en', {
  notation: 'compact',
  currency: 'USD',
  style: 'currency',
  maximumFractionDigits: 1,
  minimumFractionDigits: 0,
});

export const rates = {
  k: 1000,
  m: 1000000,
  b: 1000000000,
  t: 1000000000000,
};

export const companiesNumberOffset: { [key: string]: number } = {
  tc: 22,
  t: 22,
  c: 10,
  b: 0,
  bc: 0,
};

export const infoWindowOffsets: {
  x: { [key: string]: { [key: string]: number } };
  y: { [key: string]: { [key: string]: number } };
} = {
  x: {
    s: {
      l: 170,
      r: -170,
      c: 0,
    },
    m: {
      l: 172,
      r: -172,
      c: 0,
    },
    l: {
      l: 176,
      r: -176,
      c: 0,
    },
    xl: {
      l: 180,
      r: -180,
      c: 0,
    },
  },

  y: {
    s: {
      tc: 95,
      t: 65,
      c: 55,
      b: 40,
      bc: 10,
    },
    m: {
      tc: 99,
      t: 66,
      c: 55,
      b: 42,
      bc: 10,
    },
    l: {
      tc: 107,
      t: 66,
      c: 58,
      b: 50,
      bc: 10,
    },
    xl: {
      tc: 115,
      t: 66,
      c: 62,
      b: 59,
      bc: 10,
    },
  },
};

export const defaultCoordinates: Coordinates = {
  lat: {
    gte: null,
    lte: null,
  },
  lng: {
    gte: null,
    lte: null,
  },
};
